/* eslint-disable global-require */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getCmsContent } from 'services/api/headlessCms'

const transformBrandName = brand => {
  const brandLowerCase = brand.toLowerCase()
  switch (brandLowerCase) {
    case 'audi':
    case 'seat':
    case 'cupra':
    case 'skoda':
    case 'vw':
      return brandLowerCase
    case 'dealer':
      return 'generic'
    case 'vwc':
      return 'vwcv'
    default:
      return 'generic'
  }
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {},
    lng: 'cz',
    keySeparator: '.', // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default brandName => {
  return new Promise(res => {
    const namespaces = [
      'page',
      'validation',
      'form',
      'app',
      'step1',
      'step2',
      'step3',
      'step4',
      'error',
      'errorPayment',
      'linkExpiry',
      'customerHappinessIndex',
      'priceUpdatePopup',
      'dealerLanding',
      'licenses',
    ]
    Promise.all(
      namespaces.map(item => {
        return import(`../../resources/${brandName}/content/${item}.json`).then(module => {
          i18n.addResourceBundle('cz', item, module.default, true, true)
        })
      })
    ).then(res)
  }).then(() => {
    return getCmsContent('v1', transformBrandName(brandName), 'cs').then(res => {
      const resource = res.data
      Object.keys(resource).forEach(ns => {
        i18n.addResourceBundle('cz', ns, resource[ns], true, true)
      })
    })
  })
}
